import React from 'react';

import SummaryStatGroupCard from '~components/SummaryStatGroupCard';

import { PaymentBatchStats } from '~direct-debits/models';

interface ComponentProps {
  stats?: PaymentBatchStats;
  isLoading?: boolean;
}

const BatchStatsCards: React.FC<ComponentProps> = ({ stats, isLoading = false }) => {
  // Cancelled is part of the API response but intentionally not surfaced as a
  // tile — operators care about the in-flight pipeline, not historical cancels.
  const safe: PaymentBatchStats = stats ?? {
    total: 0,
    completed: 0,
    processing: 0,
    failed: 0,
    cancelled: 0,
  };

  const cell = (value: number) => (isLoading ? '—' : value);

  const tiles = [
    { value: cell(safe.total), label: 'Total Batches', className: 'text-primary' },
    { value: cell(safe.completed), label: 'Completed', className: 'text-success' },
    { value: cell(safe.processing), label: 'Processing', className: 'text-warning' },
    { value: cell(safe.failed), label: 'Failed', className: 'text-danger' },
  ];

  return (
    <div className="mt-2 mb-3" data-cy="dd-payment-batches-stats">
      <SummaryStatGroupCard stats={tiles} />
    </div>
  );
};

export default BatchStatsCards;
